export const routeModuleMap = {
  "/users": "5",
  "/edit-user/edit_admin_id": "5",
  "/add-user": "5",

  "/roles": "6",
  "/add-role": "6",
  "/edit-role/role_id": "6",

  "/app-add-lead": "7",
  "/app-lead-details": "7",
  "/app-update-lead": "7",

  "/app-patients": "8",
  "/patients/add-patient": "8",
  "/patients/update-patient": "8",

  "/app-import-leads": "9",

  "/questions": "10",
  "/add-question": "10",

  "/forms": "11",
  "/forms/create-form": "11",
  "/forms/edit-form/form_id": "11",
  "/forms/patient-form/form_id": "11",

  "/branches": "12",
  "/add-branch": "12",

  "/departments": "13",
  "/add-department": "13",

  "/categories": "14",
  "/categories/update-category/category_id": "14",
  "/categories/add-categories": "14",

  "/symptoms": "15",
  "/symptoms/update-symptom/symptom_id": "15",
  "/symptoms/add-symptom": "15",

  "/diseases": "16",
  "/diseases/update-diseases/disease_id": "16",
  "/diseases/add-diseases": "16",

  "/medicines": "17",
  "/medicine/update-medicine/medicine_id": "17",
  "/medicine/add-medicine": "17",

  "/disease-medicine-mapping": "18",
  "/add-medicinemapping": "18",

  "/doctors": "19",
  "/add-doctor": "19",
  "/update-doctor": "19",

  "/symptom-medicine-mapping": "20",
  "/add-symptommedicinemapping": "20",


  // "/telecaller": "2",

  // "/receptionist": "3",

  // "/counsellor": "4",

  // "/medical": "5",

  // "/service-caller": "6"
};
